module.exports = __webpack_public_path__ + "img/171.4cf4037f.jpg";